import {
  getTargetVsActualForConfigApi,
  getTimelineApi,
  getPurchaseOrderListApi,
  getPoItemsApi,
  skipStageApi,
  moveToNextStageApi,
  getVehicleTrackingDetailApi,
  getStageDataApi,
  getPurchaseOrderApi,
  createVehicleTrackingApi,
  getBarcodeApi,
  getBusinessPartnersWithOpenPoDropdownOptionsApi,
  getVehicleTrackingReportDataApi,
  getAssignedStagesApi,
  getVehicleTrackingWorkflowsApi,
  getWorkflowStagesForVehicleTrackingApi,
  getTargetVsActualConfigForWorkflowStageApi,
  createTargetVsActualLogsApi,
  getVehicleTrackingReportListApi,
  getNextAvailableWorkflowStagesApi,
  skipAndMoveVtToAnotherWsApi,
  getVarianceReportDataV2Api,
  getInwardReportApi,
  getInwardReportWithExitTimeApi,
  getAvailableMaterialsCodesForOrganisationApi,
  captureVehicleWeightApi,
  getCameraWeightReportApi,
  getCameraWeightReportForVehicleTrackingLoadApi,
  getWeighBridgeWorkCentersApi,
  getPackTypeApi,
  createVehicleTrackingLineItemApi,
  updateVehicleTrackingLineItemApi,
  updateFieldForVehicleTrackingApi,
  getPurchaseOrderLineItemsApi,
  getVehicleTrackingLineItemsApi,
  getPurchaseOrdersAndLineItemDataApi,
  getStorageLocationsApi,
  createGrnForVehicleTrackingApi,
  getVehicleTrackingAwaitingGrnApi,
  getGrnDetailsForVehicleTrackingApi,
  updateGrnDetailsForVehicleTrackingApi,
  getPlantsApi,
  getPackTypeForPurchaseOrderLineItemApi,
  createVehicleTrackingAttachmentApi,
  getPrefillSuggestionsForVehicleTrackingLineItemsApi,
  getVehicleTrackingAttachmentsApi,
  deleteVehicleTrackingAttachmentApi,
  getTargetVsActualLogsApi,
  getTareWeightHistoryForVehicleNumberApi,
  getWorkflowStagesForWorkflowApi,
  getWorkflowStagesForCurrentUserApi,
  getBusinessPartnersDropdownOptionsApi,
  getUnitOfMeasurementsApi,
  createDimensionApi,
  getDimensionListApi,
  getVehicleTrackingLineItemQualityCheckLogApi,
  getDimensionForQualityCheckCreateLogApi,
  createVehicleTrackingLineItemQualityCheckLogApi,
  getAvailableQualityChecksForVehicleTrackingApi,
  getLogForQualityCheckApi,
  getQualityCheckListApi,
  createQualityCheckProductAndDimensionApi,
  getQualityCheckProductAndDimensionDetailApi,
  updateQualityCheckProductAndDimensionApi,
  createVehicleTrackingLineItemRejectionLogApi,
  getVehicleTrackingLineItemRejectionLogsApi,
  getVahan01DetailsApi,
  getVehicleTrackingDashboardDataApi,
  getWorkflowStagesDataForUpcomingStageRequestApi,
  getUpcomingWorkflowStageRequestApi,
  createUpcomingWorkflowStageRequestApi,
  getTenantPermissionsApi,
  getVehicleTrackingChangeLogListApi,
  getVehicleTrackingChangeLogsApi,
  getVehicleTrackingListApi,
  getAvailableStagesForWorkflowAssignedToUserApi,
  getAssignedPlantForEmployeeApi,
  getOutwardReportApi,
  getVehicleTrackingCommentsApi,
  createCommentForVehicleTrackingApi,
  uploadVehicleTrackingAttachmentsApi,
  getDocumentListForVehicleTrackingApi,
} from 'src/api/vehicleTracking';
import { getTenantFeatureFlagsApi } from 'src/api/tenant';
import {
  GET_TARGET_VS_ACTUAL_FOR_CONFIG,
  GET_TIMELINE,
  GET_PO_LIST,
  GET_PO_ITEMS,
  SKIP_STAGE,
  MOVE_TO_NEXT_STAGE,
  GET_VEHICLE_TRACKING_DETAILS,
  GET_STAGE_DATA,
  GET_PURCHASE_ORDERS,
  CREATE_VEHICLE_TRACKING,
  GET_BARCODE,
  GET_BUSINESS_PARTNER_WITH_OPEN_PO_DROPDOWN_OPTIONS,
  GET_VEHICLE_TRAKING_REPORT_DATA,
  GET_ASSIGNED_STAGES,
  GET_WORKFLOWS,
  GET_WORKFLOW_STAGES_FOR_VEHICLE_TRACKING,
  CLEAR_WORKFLOW_STAGES_FOR_VEHICLE_TRACKING,
  GET_TARGET_VS_ACTUAL_CONFIG_FOR_WORKFLOW_STAGE,
  CREATE_TARGET_VS_ACTUAL_LOGS,
  GET_VEHICLE_TRACKING_REPORT_LIST,
  GET_VEHICLE_TRACKING_LIST,
  GET_NEXT_AVAILABLE_WORKFLOW_STAGES,
  SKIP_AND_MOVE_VT_TO_ANOTHER_WS,
  GET_VARIANCE_REPORT_DATA_V2,
  GET_INWARD_REPORT,
  GET_INWARD_REPORT_WITH_EXIT_TIME,
  GET_AVAILABLE_MATERIAL_CODES,
  CAPTURE_VEHICLE_WEIGHT,
  GET_CAMERA_WEIGHT_REPORT_DATA,
  GET_WEIGH_BRIDGE_WORK_CENTERS,
  GET_PACK_TYPE,
  GET_PACK_TYPE_FOR_PURCHASE_ORDER_LINE_ITEM,
  CREATE_VEHICLE_TRACKING_LINE_ITEM,
  UPDATE_VEHICLE_TRACKING_LINE_ITEM,
  GET_PURCHASE_ORDER_LINE_ITEMS,
  GET_VEHICLE_TRACKING_LINE_ITEM,
  GET_PURCHASE_ORDERS_AND_LINE_ITEM_DATA,
  GET_STORAGE_LOCATIONS_GROUPED_BY_PLANT,
  CREATE_GRN_FOR_VEHICLE_TRACKING,
  GET_VEHICLE_TRACKING_AWAITING_GRN,
  GET_GRN_FOR_VEHICLE_TRACKING,
  UPDATE_GRN_FOR_VEHICLE_TRACKING,
  UPDATE_FIELD_FOR_VEHICLE_TRACKING,
  GET_PLANTS,
  GET_TARGET_VS_ACTUAL_LOGS,
  GET_TARE_WEIGHT_HISTORY_FOR_VEHICLE_NUMBER,
  GET_WORKFLOW_STAGES_FOR_WORKFLOW,
  GET_BUSINESS_PARTNER_DROPDOWN_OPTIONS,
  GET_UNIT_OF_MEASUREMENTS,
  CREATE_DIMENSION,
  GET_DIMENSION_LIST,
  GET_VEHICLE_TRACKING_LINE_ITEM_QUALITY_CHECK_LOG,
  GET_DIMENSION_FOR_QUALITY_CHECK_CREATE_LOG,
  CREATE_VEHICLE_TRACKING_LINE_ITEM_QUALITY_CHECK_LOG,
  GET_AVAILABLE_QUALITY_CHECKS_FOR_VEHICLE_TRACKING,
  GET_LOG_FOR_QUALITY_CHECKS,
  GET_QUALITY_CHECK_LIST,
  CREATE_QUALITY_CHECK,
  UPDATE_QUALITY_CHECK_PRODUCT_AND_DIMENSION,
  GET_QUALITY_CHECK_PRODUCT_AND_DIMENSION_DETAIL,
  CREATE_VEHICLE_TRACKING_LINE_ITEM_REJECTION_LOG,
  GET_VEHICLE_TRACKING_LINE_ITEM_REJECTION_LOGS,
  GET_VAHAN_01_DETAILS,
  GET_VEHICLE_TRACKING_DASHBOARD_DATA,
  GET_WORKFLOW_STAGES_FOR_CURRENT_USER,
  GET_WORKFLOW_STAGES_DATA_FOR_UPCOMING_STAGE_REQUEST,
  GET_UPCOMING_WORKFLOW_STAGE_REQUEST,
  CREATE_UPCOMING_WORKFLOW_STAGE_REQUEST,
  GET_TENANT_PERMISSION,
  GET_VEHICLE_TRACKING_CHANGE_LOG_LIST,
  GET_VEHICLE_TRACKING_CHANGE_LOGS,
  CREATE_VEHICLE_TRACKING_ATTACHMENT,
  GET_PREFILL_SUGGESTIONS_FOR_VEHICLE_TRACKING_LINE_ITEMS,
  GET_VEHICLE_TRACKING_ATTACHMENTS,
  DELETE_VEHICLE_TRACKING_ATTACHMENT,
  GET_TENANT_FEATURE_FLAGS,
  API_FAILED,
  GET_ASSIGNED_STAGES_FOR_WORKFLOW_ASSIGNED_TO_USER,
  GET_ASSIGNED_PLANT_FOR_EMPLOYEE,
  GET_OUTWARD_REPORT,
  RESET_VEHICLE_TRACKING_DETAILS,
  RESET_TIMELINE,
  GET_VEHICLE_TRACKING_COMMENTS,
  CREATE_COMMENT_FOR_VEHICLE_TRACKING,
  UPLOAD_VEHICLE_TRACKING_ATTACHMENTS,
  GET_DOCUMENT_LIST_FOR_VEHICLE_TRACKING,
} from 'src/redux/Actions/Type';

export function getPoItems(
  vehicleTrackingNumber,
  poID,
  tenantOrganisationId,
  workflowStageId,
) {
  return (dispatch) =>
    getPoItemsApi(
      vehicleTrackingNumber,
      poID,
      tenantOrganisationId,
      workflowStageId,
    ).then((data) => {
      dispatch({
        type: GET_PO_ITEMS,
        payload: data,
      });
      return Promise.resolve(data);
    });
}

export const getTimelineData =
  (vehicleTrackingNumber, tenantOrganisationId) => (dispatch) =>
    getTimelineApi(vehicleTrackingNumber, tenantOrganisationId).then((data) => {
      dispatch({
        type: GET_TIMELINE,
        payload: data,
      });
      return Promise.resolve(data);
    });

export const resetTimelineData = () => ({
  type: RESET_TIMELINE,
});

export const getWorkflowStagesDataForUpcomingStageRequest =
  (vehicleTrackingNumber, tenantOrganisationId) => (dispatch) =>
    getWorkflowStagesDataForUpcomingStageRequestApi(
      vehicleTrackingNumber,
      tenantOrganisationId,
    ).then((data) => {
      dispatch({
        type: GET_WORKFLOW_STAGES_DATA_FOR_UPCOMING_STAGE_REQUEST,
        payload: data,
      });
    });
export const getUpcomingWorkflowStageRequest =
  (vehicleTrackingNumber, tenantOrganisationId) => (dispatch) =>
    getUpcomingWorkflowStageRequestApi(
      vehicleTrackingNumber,
      tenantOrganisationId,
    ).then((data) => {
      dispatch({
        type: GET_UPCOMING_WORKFLOW_STAGE_REQUEST,
        payload: data,
      });
    });

export const createUpcomingWorkflowStageRequest =
  (moveToNextStageData) => (dispatch) =>
    createUpcomingWorkflowStageRequestApi(moveToNextStageData).then((data) => {
      dispatch({
        type: CREATE_UPCOMING_WORKFLOW_STAGE_REQUEST,
        payload: data,
      });
    });

export function getVehicleTrackingDetail(
  vehicleTrackingNumber,
  tenantOrganisationId,
  workflowStageId,
) {
  return async (dispatch) => {
    try {
      const data = await getVehicleTrackingDetailApi(
        vehicleTrackingNumber,
        tenantOrganisationId,
        workflowStageId,
      );
      dispatch({
        type: GET_VEHICLE_TRACKING_DETAILS,
        payload: data,
      });
      return Promise.resolve(data);
    } catch (error) {
      dispatch({
        type: API_FAILED,
        payload: {
          id: 'VEHICLE_TRACKING_NOT_FOUND',
          message:
            'Vehicle tracking details not found. Please verify the vehicle UUID or try again.',
          errorList: error?.response?.data || [],
        },
      });
      return Promise.reject(error);
    }
  };
}

export const resetVehicleTrackingDetails = () => ({
  type: RESET_VEHICLE_TRACKING_DETAILS,
});

export function getTargetVsActualForConfig(
  tenantOrganisationId,
  vehicleTrackingNumber,
  configId,
  weightBridgeEventUUID,
) {
  return (dispatch) =>
    getTargetVsActualForConfigApi(
      tenantOrganisationId,
      vehicleTrackingNumber,
      configId,
      weightBridgeEventUUID,
    ).then((data) => {
      dispatch({
        type: GET_TARGET_VS_ACTUAL_FOR_CONFIG,
        payload: data,
      });
      return Promise.resolve(data);
    });
}

export function getPurchaseOrderList(
  vehicleTrackingNumber,
  tenantOrganisationId,
  workflowStageId,
) {
  return (dispatch) =>
    getPurchaseOrderListApi(
      vehicleTrackingNumber,
      tenantOrganisationId,
      workflowStageId,
    ).then((data) => {
      dispatch({
        type: GET_PO_LIST,
        payload: data,
      });
    });
}

export const skipStage =
  (skipTimeLineStageData, tenantOrganisationId) => (dispatch) =>
    skipStageApi(skipTimeLineStageData, tenantOrganisationId).then((data) => {
      dispatch({
        type: SKIP_STAGE,
        payload: data,
      });
    });

export const moveToNextStage = (moveToNextStageData) => (dispatch) =>
  moveToNextStageApi(moveToNextStageData).then((data) => {
    dispatch({
      type: MOVE_TO_NEXT_STAGE,
      payload: data,
    });
  });

export function getStageData(
  stationId,
  tenantOrganisationId,
  selectedDirection,
  selectedPlant,
) {
  return (dispatch) =>
    getStageDataApi(
      stationId,
      tenantOrganisationId,
      selectedDirection,
      selectedPlant,
    ).then((data) => {
      dispatch({
        type: GET_STAGE_DATA,
        payload: data,
      });
      return data;
    });
}

export const getPurchaseOrder = (searchData) => (dispatch) =>
  getPurchaseOrderApi(searchData).then((data) => {
    dispatch({
      type: GET_PURCHASE_ORDERS,
      payload: data,
    });
  });

export const getPurchaseOrdersAndLineItemData = (searchData) => (dispatch) =>
  getPurchaseOrdersAndLineItemDataApi(searchData).then((data) => {
    dispatch({
      type: GET_PURCHASE_ORDERS_AND_LINE_ITEM_DATA,
      payload: data,
    });
  });

export const createVehicleTracking = (entryData) => (dispatch) =>
  createVehicleTrackingApi(entryData).then((data) => {
    dispatch({
      type: CREATE_VEHICLE_TRACKING,
      payload: data,
    });
    return Promise.resolve(data);
  });

export const getBarcode =
  (organisationId, vehicleTrackingNumber) => (dispatch) =>
    getBarcodeApi(organisationId, vehicleTrackingNumber).then((data) => {
      dispatch({
        type: GET_BARCODE,
        payload: data,
      });
      return Promise.resolve(data);
    });

export function getBusinessPartnersWithOpenPoDropdownOptions(
  tenantOrganisationId,
  businessPartnerSearchTerm,
  categoryKeyId,
) {
  return (dispatch) =>
    getBusinessPartnersWithOpenPoDropdownOptionsApi(
      tenantOrganisationId,
      businessPartnerSearchTerm,
      categoryKeyId,
    ).then((data) => {
      dispatch({
        type: GET_BUSINESS_PARTNER_WITH_OPEN_PO_DROPDOWN_OPTIONS,
        payload: data,
      });
      return Promise.resolve(data);
    });
}

export const getVehicleTrackingReportData =
  (vehicleTrackingNumber, tenantOrganisationId) => (dispatch) =>
    getVehicleTrackingReportDataApi(
      vehicleTrackingNumber,
      tenantOrganisationId,
    ).then((data) => {
      dispatch({
        type: GET_VEHICLE_TRAKING_REPORT_DATA,
        payload: data,
      });
    });

export const getAssignedStages = (profileId, directions) => (dispatch) =>
  getAssignedStagesApi(profileId, directions).then((data) => {
    dispatch({
      type: GET_ASSIGNED_STAGES,
      payload: data,
    });
  });

export const getVehicleTrackingWorkflows =
  (tenantOrganisationId, direction) => (dispatch) =>
    getVehicleTrackingWorkflowsApi(tenantOrganisationId, direction).then(
      (data) => {
        dispatch({
          type: GET_WORKFLOWS,
          payload: data,
        });
      },
    );

export const getWorkflowStagesForVehicleTracking =
  (stageId, inputData) => (dispatch) =>
    getWorkflowStagesForVehicleTrackingApi(stageId, inputData).then((data) => {
      dispatch({
        type: GET_WORKFLOW_STAGES_FOR_VEHICLE_TRACKING,
        payload: data,
      });
      return Promise.resolve(data);
    });

export const clearWorkflowStagesForVehicleTracking = () => (dispatch) =>
  dispatch({
    type: CLEAR_WORKFLOW_STAGES_FOR_VEHICLE_TRACKING,
    payload: [],
  });

export const getTargetVsActualConfigForWorkflowStage =
  (workflowStageId, vehicleTrackingNumber) => (dispatch) =>
    getTargetVsActualConfigForWorkflowStageApi(
      workflowStageId,
      vehicleTrackingNumber,
    ).then((data) => {
      dispatch({
        type: GET_TARGET_VS_ACTUAL_CONFIG_FOR_WORKFLOW_STAGE,
        payload: data,
      });
      return Promise.resolve(data);
    });

export const createTargetVsActualLogs = (data) => (dispatch) =>
  createTargetVsActualLogsApi(data).then((payloadData) => {
    dispatch({
      type: CREATE_TARGET_VS_ACTUAL_LOGS,
      payload: payloadData,
    });
  });

export function getVehicleTrackingReportList(
  tenantOrganisationId,
  pageNumber,
  searchInput,
  paginationBatchSize,
  queryString,
) {
  return (dispatch) => {
    getVehicleTrackingReportListApi(
      tenantOrganisationId,
      pageNumber,
      searchInput,
      paginationBatchSize,
      queryString,
    ).then((data) => {
      dispatch({
        type: GET_VEHICLE_TRACKING_REPORT_LIST,
        payload: data,
      });
    });
  };
}

export function getVehicleTrackingList(
  tenantOrganisationId,
  pageNumber,
  searchInput,
  tableSortOrder,
  tableSortField,
  tableFieldFilter,
  paginationBatchSize,
  queryString,
) {
  return (dispatch) =>
    getVehicleTrackingListApi(
      tenantOrganisationId,
      pageNumber,
      searchInput,
      tableSortOrder,
      tableSortField,
      tableFieldFilter,
      paginationBatchSize,
      queryString,
    ).then((data) => {
      dispatch({
        type: GET_VEHICLE_TRACKING_LIST,
        payload: data,
      });
      return data;
    });
}

export function getNextAvailableWorkflowStages(
  tenantOrganisationId,
  vehicleTrackingNumber,
) {
  return (dispatch) => {
    getNextAvailableWorkflowStagesApi(
      tenantOrganisationId,
      vehicleTrackingNumber,
    ).then((data) => {
      dispatch({
        type: GET_NEXT_AVAILABLE_WORKFLOW_STAGES,
        payload: data,
      });
    });
  };
}

export function skipAndMoveVtToAnotherWs(
  tenantOrganisationId,
  vehicleTrackingNumber,
  requestedWorkflowStageId,
) {
  return (dispatch) =>
    skipAndMoveVtToAnotherWsApi(
      tenantOrganisationId,
      vehicleTrackingNumber,
      requestedWorkflowStageId,
    ).then((data) => {
      dispatch({
        type: SKIP_AND_MOVE_VT_TO_ANOTHER_WS,
        payload: data,
      });
      return Promise.resolve(data);
    });
}

export function getVarianceReportDataV2(
  tenantOrganisationId,
  pageNumber,
  searchInput,
  paginationBatchSize,
  workflowIdList,
  materialCodeList,
  supplierList,
  queryString,
  fieldIds,
) {
  return (dispatch) =>
    getVarianceReportDataV2Api(
      tenantOrganisationId,
      pageNumber,
      searchInput,
      paginationBatchSize,
      workflowIdList,
      materialCodeList,
      supplierList,
      queryString,
      fieldIds,
    ).then((data) => {
      dispatch({
        type: GET_VARIANCE_REPORT_DATA_V2,
        payload: data,
      });
      return data;
    });
}

export function getAvailableMaterialsCodesForOrganisation(
  tenantOrganisationId,
) {
  return (dispatch) => {
    getAvailableMaterialsCodesForOrganisationApi(tenantOrganisationId).then(
      (data) => {
        dispatch({
          type: GET_AVAILABLE_MATERIAL_CODES,
          payload: data,
        });
      },
    );
  };
}

export function captureVehicleWeight(
  tenantOrganisationId,
  vehicleTrackingNumber,
  fieldType,
  tableName,
  workflowStageId,
  workCenterId,
  weightBridgeEventUUID,
  vtLoadHeaderUniqueNumber,
) {
  return (dispatch) => {
    captureVehicleWeightApi(
      tenantOrganisationId,
      vehicleTrackingNumber,
      fieldType,
      tableName,
      workflowStageId,
      workCenterId,
      weightBridgeEventUUID,
      vtLoadHeaderUniqueNumber,
    ).then((data) => {
      dispatch({
        type: CAPTURE_VEHICLE_WEIGHT,
        payload: data,
      });
    });
  };
}

export function getCameraWeightReport(
  tenantOrganisationId,
  vehicleTrackingNumber,
) {
  return (dispatch) => {
    dispatch({
      type: GET_CAMERA_WEIGHT_REPORT_DATA,
      payload: {},
    });
    return getCameraWeightReportApi(
      tenantOrganisationId,
      vehicleTrackingNumber,
    ).then((data) => {
      dispatch({
        type: GET_CAMERA_WEIGHT_REPORT_DATA,
        payload: data,
      });
      return Promise.resolve(data);
    });
  };
}

export function getCameraWeightReportForVehicleTrackingLoad(
  tenantOrganisationId,
  vehicleTrackingNumber,
  vtLoadHeaderUniqueNumber,
) {
  return (dispatch) => {
    dispatch({
      type: GET_CAMERA_WEIGHT_REPORT_DATA,
      payload: {},
    });
    return getCameraWeightReportForVehicleTrackingLoadApi(
      tenantOrganisationId,
      vehicleTrackingNumber,
      vtLoadHeaderUniqueNumber,
    ).then((data) => {
      dispatch({
        type: GET_CAMERA_WEIGHT_REPORT_DATA,
        payload: data,
      });
      return Promise.resolve(data);
    });
  };
}

export function getWeighBridgeWorkCenters(
  tenantOrganisationId,
  workCenterType,
) {
  return (dispatch) =>
    getWeighBridgeWorkCentersApi(tenantOrganisationId, workCenterType).then(
      (data) => {
        dispatch({
          type: GET_WEIGH_BRIDGE_WORK_CENTERS,
          payload: data,
        });
        return Promise.resolve(data);
      },
    );
}

export function getInwardReport(
  tenantOrganisationId,
  pageNumber,
  searchInput,
  tableSortOrder,
  tableSortField,
  tableFieldFilter,
  pageData,
  queryString,
) {
  return (dispatch) =>
    getInwardReportApi(
      tenantOrganisationId,
      pageNumber,
      searchInput,
      tableSortOrder,
      tableSortField,
      tableFieldFilter,
      pageData,
      queryString,
    ).then((data) => {
      dispatch({
        type: GET_INWARD_REPORT,
        payload: data,
      });
      return data;
    });
}

export function getInwardReportWithExitTime(
  tenantOrganisationId,
  pageNumber,
  searchInput,
  tableSortOrder,
  tableSortField,
  tableFieldFilter,
  pageData,
  queryString,
) {
  return (dispatch) =>
    getInwardReportWithExitTimeApi(
      tenantOrganisationId,
      pageNumber,
      searchInput,
      tableSortOrder,
      tableSortField,
      tableFieldFilter,
      pageData,
      queryString,
    ).then((data) => {
      dispatch({
        type: GET_INWARD_REPORT_WITH_EXIT_TIME,
        payload: data,
      });
      return data;
    });
}

export function getPackType(tenantOrganisationId) {
  return (dispatch) => {
    getPackTypeApi(tenantOrganisationId).then((data) => {
      dispatch({
        type: GET_PACK_TYPE,
        payload: data,
      });
    });
  };
}

export function getPurchaseOrderLineItems(tenantOrganisationId, poId) {
  return (dispatch) => {
    getPurchaseOrderLineItemsApi(tenantOrganisationId, poId).then((data) => {
      dispatch({
        type: GET_PURCHASE_ORDER_LINE_ITEMS,
        payload: data,
      });
    });
  };
}

export const createVehicleTrackingLineItem = (createData) => (dispatch) =>
  createVehicleTrackingLineItemApi(createData).then((data) => {
    dispatch({
      type: CREATE_VEHICLE_TRACKING_LINE_ITEM,
      payload: data,
    });
    return Promise.resolve(data);
  });

export const updateVehicleTrackingLineItem = (updateData) => (dispatch) =>
  updateVehicleTrackingLineItemApi(updateData).then((data) => {
    dispatch({
      type: UPDATE_VEHICLE_TRACKING_LINE_ITEM,
      payload: data,
    });
    return Promise.resolve(data);
  });

export function getVehicleTrackingLineItems(
  tenantOrganisationId,
  vehicleTrackingNumber,
) {
  return (dispatch) =>
    getVehicleTrackingLineItemsApi(
      tenantOrganisationId,
      vehicleTrackingNumber,
    ).then((data) => {
      dispatch({
        type: GET_VEHICLE_TRACKING_LINE_ITEM,
        payload: data,
      });
      return Promise.resolve(data);
    });
}

export function getStorageLocations(tenantOrganisationId, plantIds) {
  return (dispatch) => {
    getStorageLocationsApi(tenantOrganisationId, plantIds).then((data) => {
      dispatch({
        type: GET_STORAGE_LOCATIONS_GROUPED_BY_PLANT,
        payload: data,
      });
    });
  };
}

export const createGrnForVehicleTracking = (payload) => (dispatch) =>
  createGrnForVehicleTrackingApi(payload).then((data) => {
    dispatch({
      type: CREATE_GRN_FOR_VEHICLE_TRACKING,
      payload: data,
    });
  });

export function getVehicleTrackingAwaitingGrn(
  pageNumber,
  searchInput,
  tableSortFieldOrder,
  tableSortField,
  selectedFieldFilter,
  tableFieldFilter,
  tenantOrganisationId,
  queryString,
) {
  return (dispatch) =>
    getVehicleTrackingAwaitingGrnApi(
      pageNumber,
      searchInput,
      tableSortFieldOrder,
      tableSortField,
      selectedFieldFilter,
      tableFieldFilter,
      tenantOrganisationId,
      queryString,
    ).then((data) => {
      dispatch({
        type: GET_VEHICLE_TRACKING_AWAITING_GRN,
        payload: data,
      });
      return Promise.resolve(data);
    });
}

export function getGrnDetailsForVehicleTracking(
  tenantOrganisationId,
  vehicleTrackingNumber,
) {
  return (dispatch) => {
    getGrnDetailsForVehicleTrackingApi(
      tenantOrganisationId,
      vehicleTrackingNumber,
    ).then((data) => {
      dispatch({
        type: GET_GRN_FOR_VEHICLE_TRACKING,
        payload: data,
      });
    });
  };
}

export const updateGrnDetailsForVehicleTracking = (payload) => (dispatch) =>
  updateGrnDetailsForVehicleTrackingApi(payload).then((data) => {
    dispatch({
      type: UPDATE_GRN_FOR_VEHICLE_TRACKING,
      payload: data,
    });
  });

export const updateFieldForVehicleTracking = (payload) => (dispatch) =>
  updateFieldForVehicleTrackingApi(payload).then((data) => {
    dispatch({
      type: UPDATE_FIELD_FOR_VEHICLE_TRACKING,
      payload: data,
    });
    return Promise.resolve(data);
  });

export const getPlants = (tenantOrganisationId) => (dispatch) =>
  getPlantsApi(tenantOrganisationId).then((data) => {
    dispatch({
      type: GET_PLANTS,
      payload: data,
    });
  });

export const getPackTypeForPurchaseOrderLineItem =
  (tenantOrganisationId, purchaseOrderLineItemId) => (dispatch) =>
    getPackTypeForPurchaseOrderLineItemApi(
      tenantOrganisationId,
      purchaseOrderLineItemId,
    ).then((data) => {
      dispatch({
        type: GET_PACK_TYPE_FOR_PURCHASE_ORDER_LINE_ITEM,
        payload: data,
      });
    });

export function getTargetVsActualLogs(
  tenantOrganisationId,
  vehicleTrackingNumber,
  workflowStageId,
) {
  return (dispatch) =>
    getTargetVsActualLogsApi(
      tenantOrganisationId,
      vehicleTrackingNumber,
      workflowStageId,
    ).then((data) => {
      dispatch({
        type: GET_TARGET_VS_ACTUAL_LOGS,
        payload: data,
      });
      return Promise.resolve(data);
    });
}

export function getTareWeightHistoryForVehicleNumber(
  tenantOrganisationId,
  vehicleTrackingNumber,
) {
  return (dispatch) =>
    getTareWeightHistoryForVehicleNumberApi(
      tenantOrganisationId,
      vehicleTrackingNumber,
    ).then((data) => {
      dispatch({
        type: GET_TARE_WEIGHT_HISTORY_FOR_VEHICLE_NUMBER,
        payload: data,
      });
      return Promise.resolve(data);
    });
}

export const getWorkflowStagesForWorkflow =
  (tenantOrganisationId, workflowId) => (dispatch) =>
    getWorkflowStagesForWorkflowApi(tenantOrganisationId, workflowId).then(
      (data) => {
        dispatch({
          type: GET_WORKFLOW_STAGES_FOR_WORKFLOW,
          payload: data,
        });
      },
    );

export const getWorkflowStagesForCurrentUser =
  (tenantOrganisationId, workflowId) => (dispatch) =>
    getWorkflowStagesForCurrentUserApi(tenantOrganisationId, workflowId).then(
      (data) => {
        dispatch({
          type: GET_WORKFLOW_STAGES_FOR_CURRENT_USER,
          payload: data,
        });
      },
    );

export const getBusinessPartnersDropdownOptions =
  (tenantOrganisationId, searchTerm) => (dispatch) =>
    getBusinessPartnersDropdownOptionsApi(
      tenantOrganisationId,
      searchTerm,
    ).then((data) => {
      dispatch({
        type: GET_BUSINESS_PARTNER_DROPDOWN_OPTIONS,
        payload: data,
      });
    });

export const getUnitOfMeasurements =
  (tenantOrganisationId, searchTerm) => (dispatch) =>
    getUnitOfMeasurementsApi(tenantOrganisationId, searchTerm).then((data) => {
      dispatch({
        type: GET_UNIT_OF_MEASUREMENTS,
        payload: data,
      });
    });

export const createDimension =
  (tenantOrganisationId, searchTerm) => (dispatch) =>
    createDimensionApi(tenantOrganisationId, searchTerm).then((data) => {
      dispatch({
        type: CREATE_DIMENSION,
        payload: data,
      });
    });

export const getDimensionList =
  (tenantOrganisationId, searchTerm) => (dispatch) =>
    getDimensionListApi(tenantOrganisationId, searchTerm).then((data) => {
      dispatch({
        type: GET_DIMENSION_LIST,
        payload: data,
      });
    });

export const getQualityCheckList =
  (tenantOrganisationId, searchTerm) => (dispatch) =>
    getQualityCheckListApi(tenantOrganisationId, searchTerm).then((data) => {
      dispatch({
        type: GET_QUALITY_CHECK_LIST,
        payload: data,
      });
    });

export const createQualityCheckProductAndDimension =
  (tenantOrganisationId, searchTerm) => (dispatch) =>
    createQualityCheckProductAndDimensionApi(
      tenantOrganisationId,
      searchTerm,
    ).then((data) => {
      dispatch({
        type: CREATE_QUALITY_CHECK,
        payload: data,
      });
    });
export const updateQualityCheckProductAndDimension =
  (tenantOrganisationId, searchTerm) => (dispatch) =>
    updateQualityCheckProductAndDimensionApi(
      tenantOrganisationId,
      searchTerm,
    ).then((data) => {
      dispatch({
        type: UPDATE_QUALITY_CHECK_PRODUCT_AND_DIMENSION,
        payload: data,
      });
    });

export const getQualityCheckProductAndDimensionDetail =
  (tenantOrganisationId, qualityCheckUniqueNumber) => (dispatch) =>
    getQualityCheckProductAndDimensionDetailApi(
      tenantOrganisationId,
      qualityCheckUniqueNumber,
    ).then((data) => {
      dispatch({
        type: GET_QUALITY_CHECK_PRODUCT_AND_DIMENSION_DETAIL,
        payload: data,
      });
    });

export const getQualityCheckVehicleTrackingList =
  (tenantOrganisationId, vehicleTrackingNumber) => (dispatch) =>
    getAvailableQualityChecksForVehicleTrackingApi(
      tenantOrganisationId,
      vehicleTrackingNumber,
    ).then((data) => {
      dispatch({
        type: GET_AVAILABLE_QUALITY_CHECKS_FOR_VEHICLE_TRACKING,
        payload: data,
      });
    });

export const createVehicleTrackingLineItemRejectionLog =
  (tenantOrganisationId, vehicleTrackingLineItemId, quantity) => (dispatch) =>
    createVehicleTrackingLineItemRejectionLogApi(
      tenantOrganisationId,
      vehicleTrackingLineItemId,
      quantity,
    ).then((data) => {
      dispatch({
        type: CREATE_VEHICLE_TRACKING_LINE_ITEM_REJECTION_LOG,
        payload: data,
      });
    });

export const getVehicleTrackingLineItemRejectionLogs =
  (vehicleTrackingNumber, tenantOrganisationId) => (dispatch) =>
    getVehicleTrackingLineItemRejectionLogsApi(
      vehicleTrackingNumber,
      tenantOrganisationId,
    ).then((data) => {
      dispatch({
        type: GET_VEHICLE_TRACKING_LINE_ITEM_REJECTION_LOGS,
        payload: data,
      });
    });

export const getVehicleTrackingLineItemQualityCheckLog =
  (tenantOrganisationId, qualityCheckId, vehicleTrackingNumber) => (dispatch) =>
    getVehicleTrackingLineItemQualityCheckLogApi(
      tenantOrganisationId,
      qualityCheckId,
      vehicleTrackingNumber,
    ).then((data) => {
      dispatch({
        type: GET_VEHICLE_TRACKING_LINE_ITEM_QUALITY_CHECK_LOG,
        payload: data,
      });
    });

export const getDimensionForQualityCheckCreateLog =
  (tenantOrganisationId, qualityCheckId, vehicleTrackingNumber) => (dispatch) =>
    getDimensionForQualityCheckCreateLogApi(
      tenantOrganisationId,
      qualityCheckId,
      vehicleTrackingNumber,
    ).then((data) => {
      dispatch({
        type: GET_DIMENSION_FOR_QUALITY_CHECK_CREATE_LOG,
        payload: data,
      });
    });

export const createVehicleTrackingLineItemQualityCheckLog =
  (createData) => (dispatch) =>
    createVehicleTrackingLineItemQualityCheckLogApi(createData).then((data) => {
      dispatch({
        type: CREATE_VEHICLE_TRACKING_LINE_ITEM_QUALITY_CHECK_LOG,
        payload: data,
      });
      return Promise.resolve(data);
    });

export const getLogForQualityCheck =
  (tenantOrganisationId, qualityCheckId) => (dispatch) =>
    getLogForQualityCheckApi(tenantOrganisationId, qualityCheckId).then(
      (data) => {
        dispatch({
          type: GET_LOG_FOR_QUALITY_CHECKS,
          payload: data,
        });
      },
    );

export const getVahan01Details =
  (tenantOrganisationId, vehicleNumber) => (dispatch) =>
    getVahan01DetailsApi(tenantOrganisationId, vehicleNumber)
      .then((data) => {
        dispatch({
          type: GET_VAHAN_01_DETAILS,
          payload: data,
          error: false,
        });
        return data;
      })
      .catch((err) => {
        const errorMessage = err?.response?.data?.message;

        const errorPayload = {
          error: true,
          message: errorMessage,
        };

        dispatch({
          type: GET_VAHAN_01_DETAILS,
          payload: errorPayload,
          error: true,
        });

        return errorPayload;
      });

export const clearVahan01Details = () => ({
  type: 'CLEAR_VAHAN01_DETAILS',
});

export function getVehicleTrackingDashboardData(
  tenantOrganisationId,
  startDate,
  endDate,
  selectedWorkflowId,
  selectedWorkflowStageId,
) {
  return (dispatch) =>
    getVehicleTrackingDashboardDataApi(
      tenantOrganisationId,
      startDate,
      endDate,
      selectedWorkflowId,
      selectedWorkflowStageId,
    ).then((data) => {
      dispatch({
        type: GET_VEHICLE_TRACKING_DASHBOARD_DATA,
        payload: data,
      });
    });
}

export function getTenantPermissions(tenantId) {
  return (dispatch) =>
    getTenantPermissionsApi(tenantId).then((data) => {
      dispatch({
        type: GET_TENANT_PERMISSION,
        payload: data,
      });
    });
}

export const getTenantFeatureFlags = (tenantId) => (dispatch) =>
  getTenantFeatureFlagsApi(tenantId)
    .then((data) => {
      dispatch({
        type: GET_TENANT_FEATURE_FLAGS,
        payload: data,
      });
      return data;
    })
    .catch((error) => {
      throw error; // Re-throw so calling code can handle
    });

export function getVehicleTrackingChangeLogList(
  tenantOrganisationId,
  pageNumber,
  searchInput,
  paginationBatchSize,
  tableSortOrder,
  tableSortField,
  tableFieldFilter,
  queryString,
) {
  return (dispatch) => {
    getVehicleTrackingChangeLogListApi(
      tenantOrganisationId,
      pageNumber,
      searchInput,
      paginationBatchSize,
      tableSortOrder,
      tableSortField,
      tableFieldFilter,
      queryString,
    ).then((data) => {
      dispatch({
        type: GET_VEHICLE_TRACKING_CHANGE_LOG_LIST,
        payload: data,
      });
    });
  };
}

export const getVehicleTrackingChangeLogs =
  (tenantOrganisationId, vehicleTrackingNumber) => (dispatch) =>
    getVehicleTrackingChangeLogsApi(
      tenantOrganisationId,
      vehicleTrackingNumber,
    ).then((data) => {
      dispatch({
        type: GET_VEHICLE_TRACKING_CHANGE_LOGS,
        payload: data,
      });
    });

// Invoice Actions
export const createVehicleTrackingAttachment = (formData) => (dispatch) =>
  createVehicleTrackingAttachmentApi(formData)
    .then((data) => {
      dispatch({
        type: CREATE_VEHICLE_TRACKING_ATTACHMENT,
        payload: data,
      });
      return data;
    })
    .catch((error) => {
      throw error;
    });

export const getPrefillSuggestionsForVehicleTrackingLineItems =
  (tenantOrganisationId, vehicleTrackingNumber) => (dispatch) =>
    getPrefillSuggestionsForVehicleTrackingLineItemsApi(
      tenantOrganisationId,
      vehicleTrackingNumber,
    )
      .then((data) => {
        dispatch({
          type: GET_PREFILL_SUGGESTIONS_FOR_VEHICLE_TRACKING_LINE_ITEMS,
          payload: data,
        });
        return data;
      })
      .catch((error) => {
        throw error;
      });

export function getVehicleTrackingAttachments(
  tenantOrganisationId,
  vehicleTrackingNumber,
  attachmentType,
) {
  return (dispatch) =>
    getVehicleTrackingAttachmentsApi(
      tenantOrganisationId,
      vehicleTrackingNumber,
      attachmentType,
    )
      .then((data) => {
        dispatch({
          type: GET_VEHICLE_TRACKING_ATTACHMENTS,
          payload: data,
        });
        return data;
      })
      .catch((error) => {
        throw error;
      });
}

export const deleteVehicleTrackingAttachment =
  (tenantOrganisationId, attachmentId) => (dispatch) =>
    deleteVehicleTrackingAttachmentApi(tenantOrganisationId, attachmentId)
      .then((data) => {
        dispatch({
          type: DELETE_VEHICLE_TRACKING_ATTACHMENT,
          payload: data,
        });
        return data;
      })
      .catch((error) => {
        throw error;
      });

export function getAvailableStagesForWorkflowAssignedToUser(
  tenantOrganisationId,
  workflowId,
  direction,
) {
  return (dispatch) =>
    getAvailableStagesForWorkflowAssignedToUserApi(
      tenantOrganisationId,
      workflowId,
      direction,
    )
      .then((data) => {
        dispatch({
          type: GET_ASSIGNED_STAGES_FOR_WORKFLOW_ASSIGNED_TO_USER,
          payload: data,
        });
        return data;
      })
      .catch((error) => {
        throw error;
      });
}

export const getAssignedPlantForEmployee =
  (tenantOrganisationId, searchTerm) => (dispatch) =>
    getAssignedPlantForEmployeeApi(tenantOrganisationId, searchTerm).then(
      (data) => {
        dispatch({
          type: GET_ASSIGNED_PLANT_FOR_EMPLOYEE,
          payload: data,
        });
        return data;
      },
    );

export function getOutwardReport(
  tenantOrganisationId,
  pageNumber,
  searchInput,
  tableSortOrder,
  tableSortField,
  tableFieldFilter,
  paginationBatchSize,
  queryString,
) {
  return (dispatch) =>
    getOutwardReportApi(
      tenantOrganisationId,
      pageNumber,
      searchInput,
      tableSortOrder,
      tableSortField,
      tableFieldFilter,
      paginationBatchSize,
      queryString,
    ).then((data) => {
      dispatch({
        type: GET_OUTWARD_REPORT,
        payload: data,
      });
      return data;
    });
}

export const getVehicleTrackingComments =
  (tenantOrganisationId, vehicleTrackingNumber) => (dispatch) =>
    getVehicleTrackingCommentsApi(
      tenantOrganisationId,
      vehicleTrackingNumber,
    ).then((data) => {
      dispatch({
        type: GET_VEHICLE_TRACKING_COMMENTS,
        payload: data,
      });
      return Promise.resolve(data);
    });

export const createCommentForVehicleTracking = (commentData) => (dispatch) =>
  createCommentForVehicleTrackingApi(commentData).then((data) => {
    dispatch({
      type: CREATE_COMMENT_FOR_VEHICLE_TRACKING,
      payload: data,
    });
    return Promise.resolve(data);
  });

export const uploadVehicleTrackingAttachments = (fileData) => (dispatch) =>
  uploadVehicleTrackingAttachmentsApi(fileData).then((data) => {
    dispatch({
      type: UPLOAD_VEHICLE_TRACKING_ATTACHMENTS,
      payload: data,
    });
    return Promise.resolve(data);
  });

export const getDocumentListForVehicleTracking =
  (tenantOrganisationId, vehicleTrackingNumber, searchTerm) => (dispatch) =>
    getDocumentListForVehicleTrackingApi(
      tenantOrganisationId,
      vehicleTrackingNumber,
      searchTerm,
    ).then((data) => {
      dispatch({
        type: GET_DOCUMENT_LIST_FOR_VEHICLE_TRACKING,
        payload: data,
      });
      return Promise.resolve(data);
    });
